import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Divider, Form, Input, Radio, Row, Space } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useEffect } from "react";
import SelectTree from "../../../../components/inputs/selectTree";
import { PlanoContaContabilModel } from "../../../../models/planoContaContabil/planoContaContabilModel";
import { setModalCadastrarPlanoContaContabil } from "../../../../redux/slices/planoContaContabil/planoContaContabilSlice";
import { atualizarPlanoContaContabil, cadastrarPlanoContaContabil } from "../../../../services/planoContaContabilService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";

const CadastroEdicaoPlanoContaContabil = () => {
  //estados globais
  const planoContaContabilState = useAppSelector((state) => state.planoContaContabil);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<PlanoContaContabilModel>();

  const editar = Object.values(planoContaContabilState.entity).length !== 0;

  useEffect(() => {
    if (editar) {
      form.setFieldsValue({
        ...planoContaContabilState.entity,
        sinteticoAnalitico: planoContaContabilState.entity.sinteticoAnalitico.toLowerCase(),
      });
    } else {
      form.setFieldsValue({ ativo: true, sinteticoAnalitico: "s", codigo: "" });
    }
  }, [planoContaContabilState.entity]);

  const onChangeForm = (value: PlanoContaContabilModel) => {
    if (value.idPai === 0) {
      form.setFieldValue("idPai", null);
    }
  };

  const submit = (values: any) => {
    const submitPlanoContaContabil: PlanoContaContabilModel = { ...values };

    if (editar) {
      submitPlanoContaContabil.id = planoContaContabilState.entity.id;
      dispatch(atualizarPlanoContaContabil({ value: submitPlanoContaContabil, busca: planoContaContabilState.busca }));
    } else {
      dispatch(cadastrarPlanoContaContabil({ value: values, busca: planoContaContabilState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarPlanoContaContabil(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical" onValuesChange={onChangeForm}>
      <Row gutter={12} style={{ width: "780px" }}>
        <Col span={10}>
          <Form.Item label="Item Superior" name="idPai">
            <SelectTree loading={planoContaContabilState.loading} list={planoContaContabilState.list} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item label="Código" name="codigo">
            <Input type="text" disabled />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item name="ativo" label="Ativo" valuePropName="checked">
            <Checkbox name="ativo" style={{ fontSize: "14px", paddingTop: "5px" }}>
              Ativo
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            label="Conta contábil"
            name="denominacao"
            rules={[
              {
                required: true,
                message: "Digite a denominação da conta contábil",
              },
            ]}
          >
            <Input type="text" placeholder="Digite a denominação" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Conta reduzida" name="contaReduzida">
            <Input type="text" size="small" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="sinteticoAnalitico" label="Tipo">
            <Radio.Group buttonStyle="solid">
              <Radio.Button value="s">Sintético</Radio.Button>
              <Radio.Button value="a">Analítico</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={24}>
          <Form.Item label="Descrição" name="descricao">
            <TextArea rows={3} />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroEdicaoPlanoContaContabil;
